import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  centered: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const CenterNumberRenderer = ({ value }) => {
  const classes = useStyles();
  return <div className={classes.centered}>{value}</div>;
};
CenterNumberRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CenterNumberRenderer;
